import React from 'react';
import { Form } from 'react-bootstrap';

const TextAreaWithTabs = React.memo(({ value, onChange, placeholder, rows, ...rest}) => {
    const handleTabPress = (event) => {
        if (event.key === 'Tab') {
            event.preventDefault();
            const textarea = event.target;
            const start = textarea.selectionStart;
            const end = textarea.selectionEnd;

            // Insert tab character
            const updatedValue = value.substring(0, start) + "\t" + value.substring(end);
            onChange({ target: { value: updatedValue } }); // Call onChange with the updated value

            // Move cursor after the tab
            setTimeout(() => {
                textarea.selectionStart = textarea.selectionEnd = start + 1;
            }, 0);
        }
    };

    return (
        <Form.Control
            as="textarea"
            rows={rows}  // Pass down rows prop
            placeholder={placeholder}  // Pass down placeholder prop
            value={value}  // Bind value from parent
            onChange={onChange}  // Trigger parent's onChange handler
            onKeyDown={handleTabPress}  // Handle tab press
            {...rest}
        />
    );
});

export default TextAreaWithTabs;
